import React from "react";
import { Box, Button } from "@mui/material";

const PaginationControls = ({ page, setPage }) => {
  return (
    <Box sx={{ mt: 4, display: "flex", justifyContent: "center", gap: 2 }}>
      <Button
        variant="outlined"
        disabled={page === 1}
        onClick={() => setPage((prev) => Math.max(prev - 1, 1))}>
        Previous
      </Button>
      <Button variant="outlined" onClick={() => setPage((prev) => prev + 1)}>
        Next
      </Button>
    </Box>
  );
};

export default PaginationControls;
